import React from 'react';
import { common } from '@kurtosys/ksys-app-template';

import { IGlobalConfiguration } from '../../../models/IGlobalConfiguration.js';
import { ITranslationContextValue } from '../Translate/models/ITranslationContextValue.js';
import VisuallyHidden from '../VisuallyHidden/VisuallyHidden.js';

import { ITableProps } from './models/ITableProps.js';
import { TableLogicBase } from './TableLogicBase.js';

export const VisuallyHiddenTable = (props: {
	tableProps: ITableProps;
	globalConfiguration?: IGlobalConfiguration;
	translationContext?: ITranslationContextValue;
}) => {
	const { tableProps, globalConfiguration, translationContext } = props;
	const tableLogicBase = new TableLogicBase(tableProps, globalConfiguration);
	const { columns, rows, placeholder } = tableProps;
	return (
		<VisuallyHidden>
			<table>
				<thead>
					<tr>
						{(columns || []).map((column) => (
							<th key={column.key}>{column.header}</th>
						))}
					</tr>
				</thead>
				<tbody>
					{(rows || []).map((row, index) => {
						return (
							<tr key={`row_${index}`}>
								{(columns || []).map((column) => {
									let value = tableLogicBase.formatValueForColumn(
										row[column.key],
										column,
										translationContext,
									);
									if (common.commonUtils.isNullOrUndefined(value)) {
										value = column.placeholder || placeholder;
									}
									return <td key={column.key}>{value}</td>;
								})}
							</tr>
						);
					})}
				</tbody>
			</table>
		</VisuallyHidden>
	);
};

export default VisuallyHiddenTable;
